import { Calendar, User } from 'lucide-react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ConsultantCardProps {
  id: number;
  name: string;
  role: string;
  tags: string;
  bio: string;
  image: string;
  ctaText: string;
}

const ConsultantCard = ({ id, name, role, tags, bio, image, ctaText }: ConsultantCardProps) => {
  const { t } = useTranslation();
  return (
    <div className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow duration-300 flex flex-col h-full group">
      <Link to={`/consultants/${id}`} className="block h-[410px] md:h-64 overflow-hidden bg-gray-200 relative cursor-pointer">
        <img 
          src={image} 
          alt={name} 
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-navy-900/90 to-transparent p-4 pt-12">
          <h3 className="text-xl font-bold text-white font-serif">{name}</h3>
          <p className="text-gold-400 text-sm font-medium">{role}</p>
        </div>
      </Link>
      
      <div className="p-6 flex flex-col flex-grow">
        <div className="mb-4">
          <span className="inline-block bg-navy-50 text-navy-700 text-xs px-2 py-1 rounded border border-navy-100 mb-1">
            {tags.split('|')[0].trim()}
          </span>
        </div>
        
        <p className="text-gray-600 mb-6 text-sm leading-relaxed flex-grow line-clamp-4">
          {bio}
        </p>
        
        <div className="flex gap-2 mt-auto">
          <Link to={`/consultants/${id}`} className="flex-1 py-2 px-4 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 transition-colors flex items-center justify-center text-sm font-medium">
            <User className="h-4 w-4 mr-2" />
            {t('common.details')}
          </Link>
          <Link to="/contact" className="flex-1 py-2 px-4 bg-navy-600 text-white rounded hover:bg-navy-700 transition-colors flex items-center justify-center text-sm font-medium">
            <Calendar className="h-4 w-4 mr-2" />
            {ctaText}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default ConsultantCard;
